<template>
    <submit-button class="ml-2 text-sm" size="sm" @click.prevent="show = true;">Adicionar atendente</submit-button>
    <modal
        class="min-h-full"
        :open="!!attendant || show"
        @close="close"
    >
        <h1 class="flex flex-row flex-wrap items-center content-center pb-1 mb-2 text-lg font-bold text-gray-900 dark:text-white border-b border-slate-500">
            {{ attendant ? 'Editar atendente' : 'Adicionar atendente' }}
        </h1>

        <lead-routing-attendant-form
            :key="attendant ? attendant.id : 'novo'"
            :attendant="attendant"
            @fetch="close(); $emit('fetch');"
        />
    </modal>
</template>

<script>
import Modal from "../../layouts/Modal.vue";
import SubmitButton from "../../forms/SubmitButton.vue";
import LeadRoutingAttendantForm from "../LeadRoutingAttendantForm.vue";

export default {
    props: { attendant: { type: Object, default: null } },
    components: { LeadRoutingAttendantForm, SubmitButton, Modal },
    emits: ["fetch", "close"],
    data() {
        return {
            show: false,
        }
    },
    methods: {
        close() {
            this.show = false;
            this.$emit("close");
        },
    },
}
</script>
